
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { 
  ChartContainer, 
  ChartTooltip, 
  ChartTooltipContent
} from '@/components/ui/chart';
import { ClicksByDate } from '@/hooks/product/useProductAnalytics';

interface ClicksOverTimeChartProps {
  data: ClicksByDate[];
}

export function ClicksOverTimeChart({ data }: ClicksOverTimeChartProps) {
  // Define chart colors configuration
  const chartConfig = {
    clicks: {
      label: 'Current Period',
      color: '#8884d8'
    },
    previous_clicks: {
      label: 'Previous Period',
      color: '#82ca9d'
    }
  };

  // Check if comparison data exists
  const hasComparisonData = data.some(item => item.previous_clicks !== undefined);

  return (
    <Card>
      <CardHeader>
        <CardTitle>Clicks Over Time</CardTitle>
        <CardDescription>Compare current and previous period clicks</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="h-[300px] w-full">
          {data.length > 0 ? (
            <ChartContainer config={chartConfig}>
              <LineChart data={data} margin={{ top: 5, right: 20, left: 10, bottom: 5 }}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis 
                  dataKey="date" 
                  tickLine={true}
                  axisLine={true}
                />
                <YAxis />
                <ChartTooltip
                  content={
                    <ChartTooltipContent 
                      labelClassName="font-medium text-sm"
                      labelKey="date"
                    />
                  }
                />
                <Legend />
                <Line
                  type="monotone"
                  dataKey="clicks"
                  strokeWidth={2}
                  activeDot={{ r: 6 }}
                />
                {hasComparisonData && (
                  <Line
                    type="monotone"
                    dataKey="previous_clicks"
                    strokeWidth={2}
                    activeDot={{ r: 4 }}
                    stroke={chartConfig.previous_clicks.color}
                    strokeDasharray="5 5"
                  />
                )}
              </LineChart>
            </ChartContainer>
          ) : (
            <div className="flex justify-center items-center h-full">
              <p className="text-muted-foreground">No click data available for this period</p>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
